import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Defer analytics loading until after page load + 5s delay to improve FCP/LCP
// This prevents the 300KB Statsig bundle from blocking initial render
// Analytics initialization is fire-and-forget - we don't await it
if (typeof window !== 'undefined') {
  const initializeAnalytics = () => {
    // Fire and forget - don't await to avoid blocking
    import('./utils/analytics-loader.js')
      .then(({ initializeAnalytics: init }) => {
        // Don't await - let it initialize in background
        init().catch(err => {
          // Silently fail - analytics is non-critical
          if (!import.meta.env.PROD) {
            console.error('Failed to initialize analytics:', err)
          }
        })
      })
      .catch(err => {
        // Silently fail - analytics is non-critical
        if (!import.meta.env.PROD) {
          console.error('Failed to load analytics module:', err)
        }
      })
  }

  // Wait for page load event, then add 5s delay before initializing analytics
  if (document.readyState === 'complete') {
    // Page already loaded, wait 5s
    setTimeout(initializeAnalytics, 5000)
  } else {
    // Wait for load event, then wait 5s
    window.addEventListener('load', () => {
      setTimeout(initializeAnalytics, 5000)
    }, { once: true })
  }

  // Expose experiment creation for development only
  if (import.meta.env.DEV) {
    import('./utils/createExperiment.js').then(mod => {
      window.createStatsigExperiments = mod.createAllExperiments
      window.EXPERIMENT_DEFINITIONS = mod.EXPERIMENT_DEFINITIONS
    })
  }
}

// Only use StrictMode in development to reduce production overhead
const AppWrapper = import.meta.env.DEV ? (
  <StrictMode>
    <App />
  </StrictMode>
) : (
  <App />
);

createRoot(document.getElementById('root')).render(AppWrapper)
